import React, { useState, useContext } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Paper,
  useTheme,
  IconButton,
  Tooltip,
} from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { ColorModeContext } from '../index'; 

const Login = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const [authenticating, setAuthenticating] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const signIn = async () => {
    setAuthenticating(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/hub');
    } catch (error: any) {
      setError(error.message);
      setAuthenticating(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: 2,
          position: 'relative',
        }}
      >
        {/* Theme Toggle */}
        <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
          <Tooltip
            title={`Switch to ${
              theme.palette.mode === 'light' ? 'dark' : 'light'
            } mode`}
          >
            <IconButton
              onClick={colorMode.toggleColorMode}
              color="inherit"
              size="small"
            >
              {theme.palette.mode === 'light' ? (
                <DarkModeIcon />
              ) : (
                <LightModeIcon />
              )}
            </IconButton>
          </Tooltip>
        </Box>

        <Typography
          variant="h4"
          align="center"
          sx={{ mb: 3, color: theme.palette.primary.main }}
        >
          craig&apos;s hub
        </Typography>

        <Box component="form" noValidate autoComplete="off">
          <TextField
            fullWidth
            label="Email"
            type="email"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && (
            <Typography color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            disabled={authenticating}
            onClick={signIn}
          >
            {authenticating ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Login'
            )}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;